import { Component } from '@angular/core'
import * as CryptoJS from 'crypto-js'
import { environment } from '../../environments/environment'
import { DashboardService } from './../home/dashboard/dashboard.service'
@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.scss'],
})
export class PermissionComponent {
  user: any
  options: any
  encryptedData: any
  permissionArray = []
  feature_access = []
  dashboardCall = false
  userToken: any
  constructor(private dashboardService: DashboardService) {}

  getPermissionData(type) {
    this.encryptedData = localStorage.getItem('adminInfo')
    if (this.encryptedData) {
      this.user = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretKey
        ).toString(CryptoJS.enc.Utf8)
      )
    }
    if (this.user.admin_type === 'admin') {
      return true
    } else {
      if (this.user.feature_access.length > 0) {
        this.permissionArray = []
        for (var value of this.user.feature_access) {
          this.permissionArray.push(value.public_id)
        }
        const index = this.permissionArray
          .map((datas) => {
            return datas
          })
          .indexOf(type)
        if (index === -1) {
          return false
        } else {
          return true
        }
      }
    }
  }
  dashboard(type) {
    if (localStorage.getItem('adminInfo')) {
      this.userToken = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem('adminInfo'),
          environment.secretKey
        ).toString(CryptoJS.enc.Utf8)
      )
    }
    this.dashboardService.dashboard(this.userToken.userType).subscribe(
      (res: any) => {
        this.userToken.feature_access = res.feature_access
        const setUserData: any = CryptoJS.AES.encrypt(
          JSON.stringify(this.userToken),
          environment.secretKey
        ).toString()
        if (this.user.admin_type === 'sub_admin') {
          localStorage.setItem('adminInfo', setUserData)
        }
      },
      (err: any) => {
        this.dashboardService.log_out(err.status)
      }
    )
  }
}
